// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"sp-management-pill_wrapper__OQWCe","pill":"sp-management-pill_pill__Zy6W1","pillItem":"sp-management-pill_pillItem__34bIn"};